<template>
	<div class="display-flex">
		<div class="pr-2" v-if="toolPlacementIcon">
			<SIcon :name="toolPlacementIcon" />
		</div>
		<h1 class="med" :class="{ 'first-letter-uppercase': toolPlacementIcon }">{{ toolPlacementTitle }}</h1>
	</div>
</template>

<script>
import { TOOL_PLACEMENTS } from '../ChooseToolPlacement/ChooseToolPlacement.const';
export default {
	name: 'ToolPlacementHeader',
	props: { toolPlacementId: { type: String } },
	computed: {
		toolPlacement() {
			return TOOL_PLACEMENTS[this.toolPlacementId];
		},
		toolPlacementTitle() {
			return this.toolPlacement.headerTitle || this.toolPlacement.title;
		},
		toolPlacementIcon() {
			return this.toolPlacement.toolIcon;
		},
	},
};
</script>

<style lang="scss" scoped></style>
